<template>
  <modal
    name="error-dialog"
    width="80%"
    height="auto"
    :scrollable="true"
    style="z-index: 9999;"
  >
    <div class="p-5">
      <h2>{{ title }}</h2>
      <h4 v-if="message">{{ message }}</h4>
      <div v-if="errorObj && typeof errorObj !== 'object'">
        {{ extractErrorContent(errorObj) }}
      </div>
      <div v-if="errorObj && typeof errorObj === 'object'">
        <div
          class="error-section"
          v-for="(key, index) of Object.keys(errorObj)"
          :key="index"
        >
          <h4>{{ getDisplayKey(key) }}</h4>
          <div v-if="Array.isArray(errorObj[key])">
            <li
              v-for="(value, valIndex) of errorObj[key]"
              :key="'val-' + valIndex"
            >
              {{ value }}
            </li>
          </div>
          <div v-else>
            <li>{{ errorObj[key] }}</li>
          </div>
        </div>
      </div>
      <hr />
      <button
        class="mylisting-button secondary-button"
        @click="closeErrorDialog()"
        style=""
      >
        {{ closeLabel }}
      </button>
    </div>
  </modal>
</template>
<script>
/* This component is used to show error dialog.
To show an error, call this.showErrorDialog(errorObject)
Structure of errorObject:
{
    title: 'String',
    message: 'String',
    closeLabel: 'String', <- This field is optional, if not set, use default: Close
    onCloseCallback: function reference <- This field is optional, if set, the function will be called after close dialog
    onCloseCallbacData: object <- This field is optional, it is parameter of onCloseCallback function
}

*/
import { REGEX_EXTRACT_TAG_CONTENT } from "../../constants/regex";

export default {
  name: "ErrorDialog",
  data: function() {
    return {
      title: "",
      message: "",
      errorObj: null,
      closeLabel: "",
      onCloseCallback: null,
      onCloseCallbackData: null
    };
  },
  methods: {
    extractErrorContent(content) {
      if (typeof content !== "string") {
        return content;
      }
      const matchArr = content.match(REGEX_EXTRACT_TAG_CONTENT);
      if (matchArr != null) {
        return matchArr[1];
      }
      return content;
    },
    closeErrorDialog() {
      this.$modal.hide("error-dialog");
      if (this.onCloseCallback) {
        if (!this.onCloseCallbackData) {
          this.onCloseCallback();
        } else {
          this.onCloseCallback(this.onCloseCallbackData);
        }
      }
      this.showErrorDialog(null);
    },
    showError(errorDialog) {
      this.title = errorDialog.title;
      this.message = errorDialog.message;
      this.errorObj = errorDialog.errorObj;
      if (errorDialog.messageList) {
        this.messageList = errorDialog.messageList;
      }
      if (!errorDialog.closeLabel) {
        this.closeLabel = "Close";
      } else {
        this.closeLabel = errorDialog.closeLabel;
      }
      this.onCloseCallback = errorDialog.onCloseCallback;
      this.onCloseCallbackData = errorDialog.onCloseCallbackData;
      this.$modal.show("error-dialog");
    },
    getDisplayKey(key) {
      if (key === "reply_address") {
        return "email address";
      } else {
        return key;
      }
    }
  },
  created() {
    this.$store.watch(
      state => state.dialogs.errorDialog,
      value => {
        if (this.$store.getters.loadingReqNumber > 0) {
          return;
        }
        if (!value) {
          this.$modal.hide("error-dialog");
          this.showErrorDialog(null);
        } else {
          this.showError(value);
        }
      },
      { immediate: true }
    );

    this.$store.watch(
      state => state.dialogs.loadingReqNumber,
      value => {
        if (value > 0) {
          return;
        }
        const errorDialog = this.$store.getters.errorDialog;
        if (errorDialog == null) {
          return;
        }
        this.showError(errorDialog);
      },
      { immediate: true }
    );
  }
};
</script>

<style scoped>
.error-section {
  margin-top: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/common/ErrorDialog.vue